import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { BaseService } from "./Service";
import { lvString, lvValues } from "@eres/core/dist/StringUtils";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { AppLVStrings, AppStrings } from "@10x/coreapp";
import { LocaleUtil } from "@eres/core";

type StringProvider = { [ key: string ]: LocaleValue }
declare module "@10x/coreapp" {
	export interface AppStringKeys {
		[ k: string ]: any;
	}

	export type AppLVStrings = {
		[k in keyof AppStringKeys]: LocaleValue
	}
	export type AppStrings = {
		[k in keyof AppStringKeys]: string
	}
}

export interface AssetService extends BaseService {
	registerStringProvider( provider: StringProvider, poolName?: string ): void;

	Strings( poolName?: string ): AppStrings;

	LVStrings( poolName?: string ): AppLVStrings;
}


class AssetServiceImpl implements AssetService {

	stringProviders: { [ k: string ]: StringProvider[] } = {};
	_Strings: { [ k: string ]: AppStrings } = {};
	_lvStrings: { [ k: string ]: AppLVStrings } = {};

	registerStringProvider( provider: StringProvider, poolName: string = "main" ): void {
		let pool = this.stringProviders[ poolName ];
		if ( !pool ) {
			pool = [];
			this.stringProviders[ poolName ] = pool;
		}
		pool.push( provider );
	}

	onPreInitDone(): void {
		this.buildStrings();
	}

	buildStrings() {
		const poolNames = Object.keys( this.stringProviders );
		for ( const poolName of poolNames ) {
			const providers = this.stringProviders[ poolName ];
			const values = providers.reduce( ( previousValue, currentValue ) => {
				return {
					...previousValue,
					...currentValue,
				};
			}, {} );
			if ( poolName === "main" ) {
				this._Strings[ poolName ] = { ...Strings, ...lvString( values ) } as AppStrings;
				this._lvStrings[ poolName ] = { ...LVStrings, ...lvValues( values ) } as AppLVStrings;
				for ( const key of Object.keys( values ) ) {
					if ( !Strings.hasOwnProperty( key ) ) {
						Strings[ key ] = LocaleUtil.getLocalValue( values[ key ] );
						LVStrings[ key ] = values[ key ];
					}
				}
			} else {
				this._Strings[ poolName ] = { ...lvString( values ) } as AppStrings;
				this._lvStrings[ poolName ] = { ...lvValues( values ) } as AppLVStrings;
			}
		}

	}

	LVStrings( poolName: string = "main" ): AppLVStrings {
		return this._lvStrings[ poolName ];
	}

	Strings( poolName: string = "main" ): AppStrings {
		return this._Strings[ poolName ];
	}

}

const assetService = new AssetServiceImpl();
export default assetService;

